/*
 * @Author: MWeiLiu
 * @Date: 2019-12-18 12:30:10
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-18 13:58:38
 */

// 图片上传
export const baseUploadImg = 'api/Base/upload'
// 列表
export const getArtivleList = 'api/Article/getArtivleList'
// 子栏目列表
export const getColumnId = 'api/Column/getColumnId'
// 文章详情
export const getArtivleDetails = 'api/Article/getArtivleDetails'
// 栏目列表及所属栏目下列表
export const getArtivleListByColumnId = 'api/Article/getArtivleListByColumnId'
// 合作伙伴
export const getLinksList = 'api/Index/getLinksList'
// 公共基因库对比字段
export const getFiledList = 'api/Database/getFiledList'
// 公共基因库对比
export const getDataContrast = 'api/Datacontrast/getDataContrast1'
// 客户中心用户信息
export const getUserInfo = 'api/Userinfo/getUserInfo'
// 登录接口
export const login = 'api/User/login'
// 注册接口
export const register = 'api/User/register'
// 注册接口
export const verify = 'api/user/verify'
// 修改密码
export const UpdatePassword = 'api/Updatepassword/UpdatePassword'
// 修改用户信息
export const updateUserInfo = 'api/Userinfo/updateUserInfo'
// 修改头像
export const uploadImg = 'api/Userinfo/userheadImg'
// 订单列表
// export const getOrderList = 'api/Order/getOrderList' // old
export const getOrderList = 'api/Order/getList' // new
// 订单详情
// export const getOrderDetails = 'api/order/getOrderDetails' // old
export const getOrderDetails = 'api/Order/getDetail' // old

// 文献下载区列表
export const getWebArticleList = 'api/Article/getWebArticleList'
// 文献下载区列表
export const getWebArticledetails = 'api/Article/getWebArticledetails'
// 发布文献
export const articleRelease = 'api/Article/articleRelease'
// 文献封面
export const articleupload = 'api/Article/articleCoverImg'
// 文献附件
export const uploadFiles = 'api/Article/uploadFiles'
// 文献列表
export const getWebArticleUserList = 'api/Article/getWebArticleUserList'
// 删除文献
export const articleDelete = 'api/Article/articleDelete'
// 文献编辑
export const articleEdit = 'api/Article/articleEdit'
// 查询对比列表
export const getSceneordeList = 'api/Sceneorder/getOrderList'
// 查询对比详情
export const getSceneorderDetails = 'api/Sceneorder/getOrderDetails'
// 查询对比
export const getDataContrasts = 'api/Contrast/getDataContrast'
// 客户中心查询对比记录列表
export const getList = '/api/Genelog/getList'
// 客户中心查询对比记录详情
export const getResultById = 'api/Genelog/getResultById'
// 通过类型获取数据字典
export const getByType = 'api/SysDict/getByType'
// 订单添加
export const OrederAdd = '/api/Order/add'
// 获取订单状态
export const orderTypes = '/api/SysDict/getOrderStatus'
// 订单编辑
export const orderEdit = '/api/Order/edit'
// 上传订单
export const orderUpload = '/api/Order/upload'
// 获取网站信息
export const getSystemConfig = '/api/Base/getSystemConfig'



// WEBPACK FOOTER //
// ./src/assets/js/api.js